import {
  PaginationProps as MantinePaginationProps,
  Pagination as MantinePagination,
} from '@mantine/core';

export type PaginationProps = MantinePaginationProps;

export const Pagination = MantinePagination;

Pagination.displayName = 'Pagination';
